
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component } from '@angular/core';
import { RouterModule, Routes, Router } from '@angular/router';
import { renewPolicyModel } from '../../../Models/policyModel';
import { mdlProposalAddRes_Upgrade } from '../../../Models/mdlProposalAddRes_Upgrade';
import { mdlCheckEligibilityRes } from '../../../Models/mdlCheckEligibilityRes';
import { mdlPayFortRequestDetailsReq } from "../../../Models/mdlPayFortRequestDetailsReq";
import { mdlPayFortRequestDetailsRes } from "../../../Models/mdlPayFortRequestDetailsRes";
import { LanguageService } from './../../../Services/languageService';
import { Subscription } from "rxjs";
import { restURL } from "../../../Models/restURL";
import { ProposalModel } from "../../../Models/ProposalModel";
import Swal from 'sweetalert2';
import { motorProposalService } from '../../../Services/motorProposalService';
import { mdlSadadBillerReq } from '../../../Models/mdlSadadBillerReq';
import { mdlSadadBillerRes } from '../../../Models/mdlSadadBillerRes';
import { mdlPayloadRequest } from '../../../Models/mdlPayloadRequest';
import { mdlPayloadResponse } from '../../../Models/mdlPayloadResponse';
import { userService } from '../../../Services/userService';




@Component({
  selector: 'PayfortPaymentUpgrade',
  templateUrl: './PayfortPaymentUpgrade.html',
  styleUrls: ['./PayfortPaymentUpgrade.css']
})
export class PayfortPaymentUpgrade {

  public agreeTerms: boolean = false;
  public PMethod: string;
  public ProposalNo: string;
  public InsuredName: string;
  public TotalPremium: number;
  public Lng: string;
  public LngSubscription: Subscription;
  public RegNo: string;
  public httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
  public objProposalAddRes_Upgrade: mdlProposalAddRes_Upgrade = new mdlProposalAddRes_Upgrade();
  public proposalObj: ProposalModel = new ProposalModel();
  public isShowLoading: boolean = false;
  public objCheckEligibilityRes: mdlCheckEligibilityRes = new mdlCheckEligibilityRes();
  public objmdlPayFortRequestDetailsReq: mdlPayFortRequestDetailsReq = new mdlPayFortRequestDetailsReq();
  public objmdlPayFortRequestDetailsRes: mdlPayFortRequestDetailsRes = new mdlPayFortRequestDetailsRes();
  public objGenerateBillReq: mdlSadadBillerReq = new mdlSadadBillerReq();
  public objGenerateBillRes: mdlSadadBillerRes = new mdlSadadBillerRes();
  public BillExpiryDate: string;
  public BillExpiryTime: string;
  public objPayloadRequest: mdlPayloadRequest = new mdlPayloadRequest();
  public objPayloadResponse: mdlPayloadResponse = new mdlPayloadResponse();


  constructor(private EncriptService: motorProposalService, private router: Router, private http: HttpClient, public url: restURL, private lngService: LanguageService,private userinfo: userService) {

    this.LngSubscription = this.lngService.grtLng().subscribe(lng => {
      this.Lng = lng
    });

    if (sessionStorage.getItem("Language") != null) {
      this.Lng = sessionStorage.getItem("Language");
    }
    else {
      this.Lng = "en";
    }
    this.RegNo = sessionStorage.getItem("RegNo");
    this.BindInfo();

  }


  ///<<<<<<<METHOD GetPamentRequestDetails START>>>>>>
  public GetPamentRequestDetails_Upgrade() {
    if (!this.agreeTerms) {
      Swal("Please Check Agree terms Button");
      return;
    }
    this.objmdlPayFortRequestDetailsReq.ProposalNo = this.ProposalNo;
    this.objmdlPayFortRequestDetailsReq.RegNo = sessionStorage.getItem("RegNo");
    if (this.PMethod != undefined || this.PMethod != null) {
      this.objmdlPayFortRequestDetailsReq.PaymentMethod = this.PMethod;
    } else {
      Swal("Please Select Payment Method");
      return;
    }
    if (this.objmdlPayFortRequestDetailsReq.PaymentMethod == "SDB") {
      this.GenerateBill();
    } else {
      sessionStorage.setItem("PaymentType", this.objmdlPayFortRequestDetailsReq.PaymentMethod);
      if (this.objmdlPayFortRequestDetailsReq.PaymentMethod == 'MD') {
        this.objmdlPayFortRequestDetailsReq.PaymentMethod = "CR";
      }
      this.objmdlPayFortRequestDetailsReq.Language = this.Lng;
      this.objmdlPayFortRequestDetailsReq.ProductCode = "5520";
      this.objmdlPayFortRequestDetailsReq.Email_Id = this.proposalObj.Email ? this.proposalObj.Email : "";
      this.isShowLoading = true;
      this.http.post<mdlPayFortRequestDetailsRes>(this.url.UpgradeURL + "/Motor/GetPayFortRequestDetails", this.objmdlPayFortRequestDetailsReq, this.httpOptions).toPromise().then((objResponse) => {
        this.objmdlPayFortRequestDetailsRes = objResponse;
        this.isShowLoading = false;
        if (this.objmdlPayFortRequestDetailsRes.RESULT == "0") {
          if (this.Lng == "en") {
            Swal("", "<h4 style='color:red'>" + this.objmdlPayFortRequestDetailsRes.ERROR_MSG + "</h4> ", "error");
            return;
          } else {
            Swal("", "<h4 style='color:red'>" + this.objmdlPayFortRequestDetailsRes.ERROR_MSG + "</h4> ", "error");
            return;
          }
        } else {
          sessionStorage.setItem("MERCHANT_REFERENCE", this.objmdlPayFortRequestDetailsRes.merchant_reference);
          localStorage.clear();
          localStorage.setItem("ProposalNo", this.objmdlPayFortRequestDetailsReq.ProposalNo);
          localStorage.setItem("MERCHANT_REFERENCE", this.objmdlPayFortRequestDetailsRes.merchant_reference);
          sessionStorage.setItem("objmdlPayFortRequestDetailsRes", JSON.stringify(this.objmdlPayFortRequestDetailsRes));
          this.router.navigate(['/NewDashboard/PayfortConfirmUpgrade']);
        }
      }, (error) => {
        this.isShowLoading = false;
        Swal("", "<h4 style='color:red'>" + JSON.stringify(error) + "</h4> ", "error");
      });
    }

  }
  ///<<<<<<<METHOD GetPamentRequestDetails END>>>>>>



  GenerateBill() {
    this.objGenerateBillReq.ProposalNo = this.ProposalNo;
    this.objGenerateBillReq.RegNo = sessionStorage.getItem("RegNo");
    this.objGenerateBillReq.ProductCode = "5520";
    this.objGenerateBillReq.Token = this.userinfo.getToken();
    this.objGenerateBillReq.Lang = sessionStorage.getItem("Language");
    this.isShowLoading = true;

    this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(this.objGenerateBillReq));

    //this.http.post<mdlSadadBillerRes>(this.url.baseURL + "/Payfort/GenerateBill", this.objGenerateBillReq, this.userinfo.getHttpOptions())
    this.http.post<mdlPayloadResponse>(this.url.baseURL + "/Payfort/GenerateBill", this.objPayloadRequest, this.userinfo.getHttpOptions())
      .toPromise().then((result) => {
        this.isShowLoading = false;
        //this.objGenerateBillRes = result;
        //New Line Start
        this.objPayloadResponse = result;
        this.objGenerateBillRes = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
        //NewLine End

        if (this.objGenerateBillRes.StatusCode == "S") {
          this.BillExpiryDate = this.objGenerateBillRes.BillExpiryDate.split("T")[0];
          this.BillExpiryTime = this.objGenerateBillRes.BillExpiryDate.split("T")[1];
          if (sessionStorage.getItem("Language") == "en")
            Swal("You can pay before " + this.BillExpiryDate + " " + this.BillExpiryTime + ", by selecting the company code 196 via SADAD system");
          else
            //swal(" باختيار رمز الشركة 196 عبر نظام سداد،" + " " + this.BillExpiryTime + " " + this.BillExpiryDate + " " + " يمكنكم السداد قبل " + this.objGenerateBillRes.BillNo + " تم إصدار فاتورة سداد");

            Swal(" تم إصدار فاتورة سداد" + "  " + this.objGenerateBillRes.BillNo + "   " + " يمكنكم السداد قبل " + " " + this.BillExpiryTime + " " + this.BillExpiryDate + " " + " باختيار رمز الشركة 196 عبر نظام سداد،");
          this.router.navigate(['/NewDashboard/Proposals']);
        } else {
          Swal(this.objGenerateBillRes.StatusDesc);
          this.router.navigate(['/NewDashboard/Proposals']);
        }

      }, (error) => {
        this.isShowLoading = false;
        Swal("Invalid!,Please try again later");
    });


  }









  //<<<<<<<<<<<BIND INFO START>>>>>>>>>>>>>

  public BindInfo() {
    let UrlString = this.router.routerState.snapshot.url.split(":");
    let UrlRedirectType = UrlString[1];
    if (UrlRedirectType == "Confirm") {
      this.objProposalAddRes_Upgrade = JSON.parse(sessionStorage.getItem("objProposalAddRes_Upgrade"));
      this.objCheckEligibilityRes = JSON.parse(sessionStorage.getItem("objCheckEligibilityRes"));
      this.ProposalNo = this.objProposalAddRes_Upgrade.ProposalNo;
      this.InsuredName = this.Lng == "en" ? sessionStorage.getItem("InsuredName") : sessionStorage.getItem("NameAr");
      this.TotalPremium = this.objCheckEligibilityRes.TOTAL_AMOUNT_UPGRADE;
    }
    else if (UrlRedirectType == "DashBoard") {
      //this.proposalObj = JSON.parse(sessionStorage.getItem("paymentObj"));
      this.proposalObj = JSON.parse(this.EncriptService.DecriptObject(sessionStorage.getItem("paymentObj")));

      this.ProposalNo = this.proposalObj.ProposalNo;
      this.InsuredName = this.proposalObj.Name;
      this.TotalPremium = this.objCheckEligibilityRes.TOTAL_AMOUNT_UPGRADE ? this.objCheckEligibilityRes.TOTAL_AMOUNT_UPGRADE : this.proposalObj.TotalPremium;
    }
  }

  //<<<<<<<<<<<BIND INFO END>>>>>>>>>>>>>

}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/PayfortUpgrade/PayfortPaymentUpgrade/PayfortPaymentUpgrade.ts